function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.80469 7.16667L10.0047 11.7L14.2047 7.16667H11.8047V1.5H8.20469V7.16667H5.80469Z",
  stroke: "current",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.4 1.5H17.8C18.4624 1.5 19 2.00773 19 2.63333V17.3667C19 17.9923 18.4624 18.5 17.8 18.5H2.2C1.5376 18.5 1 17.9923 1 17.3667V2.63333C1 2.00773 1.5376 1.5 2.2 1.5H4.6",
  stroke: "current",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 15.1016H19",
  stroke: "current",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgDownloadPdf = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDownloadPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download_pdf.28829ea3.svg";
export { ForwardRef as ReactComponent };